import { Tooltip } from "antd";
import moment from "moment";
import React from "react";
const StartEndDateComponent = ({ item, DATE_FORMAT = "D MMM YY" }: any) => {
  const {
    mode,
    offlineStartDate,
    offlineEndDate,
    onlineStartDate,
    onlineEndDate,
  } = item || {};
  const renderingTime = (date: any) => {
    return <div className="d-flex">{moment(date).format(DATE_FORMAT)}</div>;
  };
  return (
    <div>
      {mode === "Both" ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            minWidth: 0,
          }}
        >
          {/* Online row */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              flexWrap: "nowrap",
            }}
          >
            <Tooltip
              title={
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{
                      width: 7,
                      height: 7,
                      borderRadius: "50%",
                      background: "#22c55e",
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  <span style={{ fontWeight: 600 }}>Online:</span>
                </span>
              }
              color="#1f2937"
              placement="top"
            >
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "3px",
                  padding: "1px 7px",
                  borderRadius: "10px",
                  fontSize: "11px",
                  fontWeight: 600,
                  background:
                    "linear-gradient(135deg, #e6f9ee 0%, #d0f0e0 100%)",
                  color: "#1a8a4a",
                  border: "1px solid #a7d9b8",
                  letterSpacing: "0.3px",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  minWidth: "54px",
                  justifyContent: "center",
                  cursor: "default",
                }}
              >
                <span
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#22c55e",
                    display: "inline-block",
                  }}
                />
                {renderingTime(onlineStartDate)}
                <span style={{ color: "#9ca3af", margin: "0 3px" }}>→</span>
                {renderingTime(onlineEndDate)}
              </span>
            </Tooltip>
          </div>
          {/* Offline row */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              flexWrap: "nowrap",
            }}
          >
            <Tooltip
              title={
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{
                      width: 7,
                      height: 7,
                      borderRadius: "50%",
                      background: "#9ca3af",
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  <span style={{ fontWeight: 600 }}>Offline:</span>
                </span>
              }
              color="#1f2937"
              placement="top"
            >
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "3px",
                  padding: "1px 7px",
                  borderRadius: "10px",
                  fontSize: "11px",
                  fontWeight: 600,
                  background:
                    "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)",
                  color: "#4b5563",
                  border: "1px solid #d1d5db",
                  letterSpacing: "0.3px",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  minWidth: "54px",
                  justifyContent: "center",
                  cursor: "default",
                }}
              >
                <span
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#6b7280",
                    display: "inline-block",
                  }}
                />
                {renderingTime(offlineStartDate)}
                <span style={{ color: "#9ca3af", margin: "0 3px" }}>→</span>
                {renderingTime(offlineEndDate)}
              </span>
            </Tooltip>
          </div>
        </div>
      ) : (
        <div className="d-flex">
          {renderingTime(
            mode === "Online" ? onlineStartDate : offlineStartDate
          )}{" "}
          {"→"}
          {renderingTime(
            mode === "Online" ? onlineEndDate : offlineEndDate
          )}{" "}
        </div>
      )}
    </div>
  );
};

export default StartEndDateComponent;
